import { gql } from "graphql-request"
import { ProductCardType } from "../enum/Enum.ts";
import { ServiceGraphql } from "./Graphql"

export const graphGetAllContractByCustomer = async (contractType) => {
  const ALL_CONTRACTS = gql`
  query AllContracts($filter: ContractFilter) {
    AllContracts(filter: $filter)  {
      items {
        contractDetails {
          way4Response {
            data
            status
          }
        }
        contractName
        contractNumber
        contractStatus
        contractType
        customerId
        embossingName
        expiredDate
        id
        issuedDate
        parentContractId
        product {
          cardType
          pinLength
          productCode
          name
          liabCode
          brandName
        }
        productId
        way4Contract
      }
    }
  }
  `
  const variables = {
    "filter": {
      "contractType": !contractType ? [ProductCardType.CREDIT, ProductCardType.PREPAID] : contractType,
      "isDelete": 0
    },
    "options": {
      "fetchAll": true
    }
  }

  const response = await ServiceGraphql.request(ALL_CONTRACTS, variables);
  return response.AllContracts;
};

export const graphOpenNewContract = async (data) => {
  const OPEN_NEW_CONTRACT = gql`
  mutation OpenNewContract($data: OpenNewContractDto!) {
    OpenNewContract(data: $data) {
      contractId
      contractPresignedUrl
      contractS3Key
      customerId
    }
  }
  `

  const variables = {
    "data": data
  }

  const response = await ServiceGraphql.request(OPEN_NEW_CONTRACT, variables);
  return response.OpenNewContract;
};

export const graphCreateNewWay4Contract = async (contractId) => {
  const CREATE_NEW_WAY4_CONTRACT = gql`
mutation CreateNewWay4Contract($contractId: Int!) {
  CreateNewWay4Contract(contractId: $contractId) {
    contractName
    contractNumber
    contractStatus
    contractType
    customerId
    embossingName
    expiredDate
    id
    issuedDate
    product {
      cardType
      pinLength
      productCode
      liabCode
    }
    way4Contract
  }
}
`

  const variables = {
    "contractId": contractId
  }

  const response = await ServiceGraphql.request(CREATE_NEW_WAY4_CONTRACT, variables);
  return response.CreateNewWay4Contract;
}

export const graphGetCardInfo = async (contractSearchMethod, contractIdentifier) => {
  const GET_CARD = gql`
  query GetCard($contractIdentifier: String!, $contractSearchMethod: Way4ContractSearchMethod!) {
    GetCard(contractIdentifier: $contractIdentifier, contractSearchMethod: $contractSearchMethod) {
      data
      status
    }
  }
  `
  const variables = {
    "contractIdentifier": contractIdentifier,
    "contractSearchMethod": contractSearchMethod
  }

  const response = await ServiceGraphql.request(GET_CARD, variables);
  return response.GetCard
}


export const contractDetails = async (contractId) => {
  const GET_CONTRACT_ID = gql`
  query Contract($contractId: Int!) {
    Contract(id: $contractId) {
      contractDetails {
        createAt
        createBy
        id
        isDelete
        updateAt
        updateBy
        way4Response {
          data
          status
        }
      }
      contractName
      contractNumber
      contractStatus
      contractType
      createAt
      createBy
      customerId
      embossingName
      expiredDate
      id
      isDelete
      issuedDate
      parentContractId
      product {
        brandName
        cardType
        createAt
        createBy
        description
        id
        isDelete
        liabCode
        name
        pinLength
        productCode
        updateAt
        updateBy
      }
      productId
      updateAt
      updateBy
      way4Contract
      way4ContractId
    }
  }
  `

  const variables = {
    contractId: contractId
  }
  const response = await ServiceGraphql.request(GET_CONTRACT_ID, variables);
  return response.Contract;
};
